import styled from 'styled-components'
import { SwitchProps } from './index'

export const ToggleSwitch = styled.label`
  position: relative;
`

export const Handle = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 36px;
  width: 85px;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid #e3e7ed;
  background-color: #f7f9fc;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.22);
  cursor: pointer;

  &::after {
    content: '';
    display: block;
    border-radius: 4px;
    height: 36px;
    width: 43px;
    background-color: #41aada;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.22);
    transition: 0.2s;
  }

  &::before {
    content: 'No';
    position: absolute;
    right: 10px;
    top: 10px;
    height: 15px;
    width: 18px;
    color: #8b8b8b;
    font-size: 12px;
    line-height: 15px;
  }
`

export const Checkbox = styled.input.attrs<SwitchProps>(() => ({
  type: 'checkbox'
}))`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 85px;
  height: 36px;

  &:checked + ${Handle} {
    background: #c7e3f0;

    &::before {
      content: 'Yes';
      position: absolute;
      left: 10px;
      top: 10px;
      height: 15px;
      width: 23px;
      color: #41aada;
      font-size: 12px;
      line-height: 15px;
    }

    &::after {
      content: '';
      margin-left: 50%;
      transition: 0.2s;
    }
  }
`

export const SwitchWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > span {
    font-size: 18px;
    color: #5f5f5f;
  }
`
